import React from 'react';
import { RouteObject } from 'react-router-dom';
import ServiceRemoved from './ServiceRemoved';

export const dataPlatformRoutes: RouteObject = {
  path: 'data-platform',
  children: [
    { path: '/data-platform', element: <ServiceRemoved /> },
    { path: 'pipeline-list', element: <ServiceRemoved /> },
    { path: 'pipeline-components', element: <ServiceRemoved /> },
    { path: 'component-details', element: <ServiceRemoved /> },
  ],
};
